import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  Input,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subject } from 'rxjs';

import { BaseControlValueAccessor, IIrisFormFieldControl } from '@sondermind/iris/form-helpers';
// import { IIrisFormFieldControl } from 'iris-form-field-control.interface';
// TODO - replace import to local path once form field feature has been added

@Component({
  selector: 'iris-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: IrisTextInputComponent,
      multi: true
    }
  ],
  standalone: false
})
export class IrisTextInputComponent
  extends BaseControlValueAccessor
  implements IIrisFormFieldControl, OnDestroy, AfterViewInit {
  @Input() placeholder: string = '';
  @Input() autocomplete: string = '';
  @Input() isReadonly: boolean = false;
  @Input() type: string = 'text';
  @Input() mask: string | undefined;
  @Input() dropSpecialCharacters: boolean = true;
  @Input() maxLength: string = null;
  @Input() min: number | string | null;
  @Input() max: number | string | null;
  @Input() step: number | null;
  @Input() hasButton: boolean = false;
  @Input() hasIcon: boolean = false;
  @Input() iconRightAligned: boolean = false;
  @Input() markMaskAsPristine: boolean = true;

  private destroyed$ = new Subject<void>();

  @ViewChild('irisInputElement', { static: false }) irisInputElement: ElementRef;

  constructor(
    injector: Injector,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  override get control(): FormControl {
    return this.formControl || this.controlContainer.control.get(this.formControlName) as FormControl;
  }

  ngAfterViewInit(): void {
    // When the mask is applied,
    // it might be triggering the form control's valueChanges event,
    // making Angular think that the form has been modified
    // So mark the masked field as pristine
    if (this.mask && this.markMaskAsPristine) {
      this.control?.markAsPristine();
      // Trigger Angular to detect the change
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  focusInput(): void {
    this.irisInputElement.nativeElement.focus();
  }
}
